import React, { useContext, useRef, useState } from 'react';
import { ArrowRight, ArrowLeft } from 'react-feather';
import CustomizerContext from '../../_helper/Customizer';
import SidebarMenuItems from './SidebarMenuItems';
import "./SidebarMenu.scss";

const SidebarMenu = ({ setMainMenu, props, sidebartoogle, setNavActive, activeClass, width }) => {
  const { customizer } = useContext(CustomizerContext);
  const wrapper = customizer.settings.sidebar.type;
  const [margin, setMargin] = useState(0);

  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const menuRef = useRef(null);

  const scrollToRightNew = () => {
    if (!menuRef.current) return;
    const containerWidth = menuRef.current.offsetWidth;
    const scrollWidth = menuRef.current.scrollWidth;

    const newMargin = margin - width;
    const maxScroll = -(scrollWidth - containerWidth);

    if (newMargin <= maxScroll) {
      setMargin(maxScroll);
      setShowRight(false);
    } else {
      setMargin(newMargin);
    }
    setShowLeft(true);
  };

  const scrollToLeftNew = () => {
    const newMargin = margin + width;
    if (newMargin >= 0) {
      setMargin(0);
      setShowLeft(false);
    } else {
      setMargin(newMargin);
    }
    setShowRight(true);
  };

  const scrollToRight = () => {
    if (margin <= -2598 || margin <= -2034) {
      if (width === 492) {
        setMargin(-3570);
      } else {
        setMargin(-3464);
      }
      document.querySelector('.right-arrow').classList.add('d-none');
      document.querySelector('.left-arrow').classList.remove('d-none');
    } else {
      setMargin((margin) => (margin += -width));
      document.querySelector('.left-arrow').classList.remove('d-none');
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      document.querySelector('.left-arrow').classList.add('d-none');
      document.querySelector('.right-arrow').classList.remove('d-none');
    } else {
      setMargin((margin) => (margin += width));
      document.querySelector('.right-arrow').classList.remove('d-none');
    }
  };

  // return (
  //   <nav className="sidebar-main" id="sidebar-main">
  //     {showLeft && (
  //       <div className="left-arrow" onClick={scrollToLeft}>
  //         <ArrowLeft />
  //       </div>
  //     )}
  //     <div
  //       id="sidebar-menu"
  //       ref={menuRef}
  //       style={
  //         wrapper.split(" ").includes("horizontal-wrapper")
  //           ? { marginLeft: margin + "px", transition: "margin 0.3s ease" }
  //           : { margin: "0px" }
  //       }
  //     >
  //       <ul className="sidebar-links custom-scrollbar">
  //         <li className="back-btn">
  //           <div className="mobile-back text-end">
  //             <span>{"Back"}</span>
  //             <i className="fa fa-angle-right ps-2" aria-hidden="true"></i>
  //           </div>
  //         </li>
  //         <SidebarMenuItems
  //           setMainMenu={setMainMenu}
  //           props={props}
  //           sidebartoogle={sidebartoogle}
  //           setNavActive={setNavActive}
  //           activeClass={activeClass}
  //         />
  //       </ul>
  //     </div>
  //     {showRight && (
  //       <div className="right-arrow" onClick={scrollToRight}>
  //         <ArrowRight />
  //       </div>
  //     )}
  //   </nav>
  // );

  return (
    <nav className="sidebar-main" id="sidebar-main">
      <div className="left-arrow" onClick={scrollToLeft}>
        <ArrowLeft />
      </div>
      <div
        id="sidebar-menu"
        style={
          wrapper.split(' ').includes('horizontal-wrapper')
            ? { marginLeft: margin + 'px' }
            : { margin: '0px' }
        }
        className='lg:md-0'
      >
        <ul className="sidebar-links custom-scrollbar">
          <li className="back-btn">
            <div className="mobile-back text-end">
              <span>{'Back'}</span>
              <i className="fa fa-angle-right ps-2" aria-hidden="true"></i>
            </div>
          </li>
          <SidebarMenuItems setMainMenu={setMainMenu} props={props} sidebartoogle={sidebartoogle} setNavActive={setNavActive} activeClass={activeClass} />
        </ul>
      </div>
      {/* <div className="right-arrow" onClick={scrollToRight}>
        <ArrowRight />
      </div> */}
    </nav>
  );

};

export default SidebarMenu;